"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.ModalContainer = styled_components_1.default.div `
  position: fixed;
  z-index: 101;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  transition: ${props => props.theme.animations.primary};
  ${props => props.alwaysOnScreen && `overflow: hidden; `}
  ${props => props.alwaysOnScreen && !props.isModalOpen && 'visibility: collapse; background: rgba(0, 0, 0, 0);'}

  @media print {
    display: none;
  }
`;
exports.default = {
    ModalContainer: exports.ModalContainer
};
